export default function RiskTypeController(
  $rootScope,
  $scope,
  $q,
  alerts,
  confirmDialog,
  editRiskDialog,
  loaderService,
  assetDataService,
  riskDataService,
  riskSharedModelService,
  ssDialogService,
  editRiskTypeDialog,
  deleteRiskTypeConfirmDialog,
  controlSharedModelService
) {
  const vm = this;

  vm.canExpand = true;
  vm.isExpanded = false;

  vm.handleEditClick = _handleEditClick;
  vm.handleDeleteClick = _handleDeleteClick;
  vm.handleUnassignClick = _handleUnassignClick;
  vm.handleExpandControlClick = _handleExpandControlClick;
  vm.hasData = false;

  _activate();

  function _activate() {
    _initRiskSeverity();
    _initEventListeners();
  }

  function _initEventListeners() {
    // $scope.$on('pra_control-type-created', (event, payload) => {
    //   console.log(payload);
    // });
    // $scope.$on('pra_control-type-updated', (event, payload) => {
    //   console.log(payload);
    // });
    $scope.$on('refreshControlTypesOfRiskType', (event, opt) => {
      if (opt.riskType.customerRiskTypeId === vm.riskType.customerRiskTypeId) {
        refreshControlTypes(opt.riskType);
      }
    });

    $scope.$on('refreshControlTypes', (event, opt) => {
      if (opt.controlType) {
        _updateControlTypes(opt.controlType);
      }
    });

    $scope.$on('pra_control-type-deleted', (event, payload) => {
      if (payload.riskType && payload.riskType.customerRiskTypeId === vm.riskType.customerRiskTypeId) {
        if (vm.riskType.customerControlTypes && vm.riskType.customerControlTypes.length > 0) {
          vm.riskType.customerControlTypes = vm.riskType.customerControlTypes.filter(
            // eslint-disable-next-line max-len
            riskTypeControlType => riskTypeControlType.customerControlTypeId !== payload.controlType.customerControlTypeId
          );
        }
      }
    });
  }

  function _initRiskSeverity() {
    if (vm.riskType) {
      vm.riskType = riskSharedModelService.addSeverityDescriptionsToRiskType(vm.riskType);
      vm.riskType = riskSharedModelService.transformMeterStatusToRiskType(vm.riskType);
      vm.riskType = riskSharedModelService.addColorToProbability(vm.riskType);
    }
  }

  function _handleEditClick($event) {
    loaderService.showViewLoader = true;
    let getRiskType = null;
    if (vm.assetType) {
      // eslint-disable-next-line max-len
      getRiskType = riskDataService.getRiskTypeByAssetType(vm.riskType.customerRiskTypeId, vm.assetType.customerAssetTypeId);
    } else {
      getRiskType = riskDataService.getRiskType(vm.riskType.customerRiskTypeId);
    }
    $q.all([
      getRiskType,
      controlSharedModelService.initControlAdmin(),
      getInitRiskAdmin()
    ]).then((response) => {
      ssDialogService.dialogs.riskAdmin.editRiskTypeDialog = ssDialogService.alert(
        editRiskTypeDialog.getOptions($event, {
          risk: response[0].data,
          riskOnsets: riskSharedModelService.RiskOnsets,
          riskForewarnings: riskSharedModelService.RiskForewarnings,
          riskDurations: riskSharedModelService.RiskDurations,
          riskDataConfidentialities: riskSharedModelService.RiskDataConfidentialities,
          riskDataIntegrities: riskSharedModelService.RiskDataIntegrities,
          riskDataAvailabilities: riskSharedModelService.RiskDataAvailabilities,
          riskDirections: riskSharedModelService.RiskDirections,
          riskTrendings: riskSharedModelService.RiskTrendings,
          riskAssessmentFrequencies: riskSharedModelService.RiskAssessmentFrequencies,
          riskProbabilities: riskSharedModelService.RiskProbabilities,
          riskClassifications: riskSharedModelService.RiskClassifications,
          assetType: vm.assetType
        })
      );

      ssDialogService.show(ssDialogService.dialogs.riskAdmin.editRiskTypeDialog);
    }).finally(() => {
      $rootScope.$broadcast('refreshAssetTypes');
    });
  }

  function _handleDeleteClick($event) {
    ssDialogService.dialogs.riskAdmin.deleteRiskTypeConfirmDialog = ssDialogService.alert(
      deleteRiskTypeConfirmDialog.getOptions($event, {
        riskType: vm.riskType,
        assetType: vm.assetType,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.riskAdmin.deleteRiskTypeConfirmDialog);
  }

  function _handleUnassignClick($event) {
    ssDialogService.dialogs.assetAdmin.unassignAssetTypeTopRiskTypeDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Unassign Top Risk Type from Asset Type?',
        message: `Are you sure you want to unassign the Top Risk Type, "${vm.riskType.name}"
         from the Asset Type, "${vm.assignedAssetType.name}"?`,
        handleYesClick: _handleConfirmUnassignClick,
        handleNoClick: _handleCancelUnassignClick,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.assetAdmin.unassignAssetTypeTopRiskTypeDialog);
  }

  function _handleConfirmUnassignClick() {
    loaderService.showViewLoader = true;
    assetDataService.unassignCustomerAssetRiskType(vm.assignedAssetType.customerAssetTypeId, vm.riskType)
      .then((response) => {
        if (response.status === 200) {
          alerts.success(
            `The Risk Type "${vm.riskType.name}" was successfully unassigned from the Asset Type,
            "${vm.assignedAssetType.name}".`
          );
          $rootScope.$broadcast('refreshAssetTypes');
          $rootScope.$broadcast('refreshTopRiskTypes', { assetType: response.data });
          $rootScope.$broadcast('refreshAssetType', { assetType: response.data });
          $rootScope.$broadcast('refreshAssets', { assetType: response.data });
          _closeUnassignDialog();
          // loaderService.showViewLoader = false;
        } else {
          alerts.error('An error occurred while unassigning the Risk Type.');
          loaderService.showViewLoader = false;
        }
      });
  }

  function _handleCancelUnassignClick() {
    _closeUnassignDialog();
  }

  function _closeUnassignDialog() {
    ssDialogService.hide(ssDialogService.dialogs.assetAdmin.unassignAssetTypeTopRiskTypeDialog);
  }

  function _handleExpandControlClick() {
    if (!vm.hasData) {
      let getRiskType = null;
      if (vm.assetType) {
        // eslint-disable-next-line max-len
        getRiskType = riskDataService.getRiskTypeByAssetType(vm.riskType.customerRiskTypeId, vm.assetType.customerAssetTypeId);
      } else {
        getRiskType = riskDataService.getRiskType(vm.riskType.customerRiskTypeId);
      }
      getRiskType.then((response) => {
        vm.riskType = angular.copy(response.data);
        vm.riskType = riskSharedModelService.addSeverityDescriptionsToRiskType(vm.riskType);
        vm.riskType = riskSharedModelService.transformMeterStatusToRiskType(vm.riskType);
        vm.riskType = riskSharedModelService.addColorToProbability(vm.riskType);
        vm.hasData = true;
      });
    }
    vm.isExpanded = !vm.isExpanded;
  }

  function getInitRiskAdmin() {
    if (riskSharedModelService.RiskOnsets && riskSharedModelService.RiskOnsets.length > 0) {
      return Promise.resolve();
    }
    return riskDataService.initRiskAdmin().then((getRiskInitResponse) => {
      if (!getRiskInitResponse.data) {
        alerts.error('Error occurred get risk init data.');
      } else {
        if (getRiskInitResponse.data.RiskOnsets) {
          riskSharedModelService.RiskOnsets = getRiskInitResponse.data.RiskOnsets.result;
        }

        if (getRiskInitResponse.data.RiskForewarnings) {
          riskSharedModelService.RiskForewarnings = getRiskInitResponse.data.RiskForewarnings.result;
        }

        if (getRiskInitResponse.data.RiskDurations) {
          riskSharedModelService.RiskDurations = getRiskInitResponse.data.RiskDurations.result;
        }

        if (getRiskInitResponse.data.RiskDataConfidentialities) {
          riskSharedModelService.RiskDataConfidentialities = getRiskInitResponse.data.RiskDataConfidentialities.result;
        }

        if (getRiskInitResponse.data.RiskDataIntegrities) {
          riskSharedModelService.RiskDataIntegrities = getRiskInitResponse.data.RiskDataIntegrities.result;
        }

        if (getRiskInitResponse.data.RiskDataAvailabilities) {
          riskSharedModelService.RiskDataAvailabilities = getRiskInitResponse.data.RiskDataAvailabilities.result;
        }

        if (getRiskInitResponse.data.RiskDirections) {
          riskSharedModelService.RiskDirections = getRiskInitResponse.data.RiskDirections.result;
        }

        if (getRiskInitResponse.data.RiskTrendings) {
          riskSharedModelService.RiskTrendings = getRiskInitResponse.data.RiskTrendings.result;
        }

        if (getRiskInitResponse.data.RiskAssessmentFrequencies) {
          riskSharedModelService.RiskAssessmentFrequencies = getRiskInitResponse.data.RiskAssessmentFrequencies.result;
        }

        if (getRiskInitResponse.data.RiskProbabilities) {
          riskSharedModelService.RiskProbabilities = getRiskInitResponse.data.RiskProbabilities.result;
        }
      }
    });
  }

  function refreshControlTypes(riskType) {
    vm.riskType.customerControlTypes = vm.riskType.customerControlTypes || [];
    vm.riskType.customerControlTypes = riskType.customerControlTypes;
  }

  function _updateControlTypes(controlType) {
    if (vm.riskType.customerControlTypes && vm.riskType.customerControlTypes.length > 0) {
      // eslint-disable-next-line max-len
      const pos = vm.riskType.customerControlTypes.findIndex(item => item.customerControlTypeId === controlType.customerControlTypeId);
      if (pos === -1) return; // Can't find the item
      vm.riskType.customerControlTypes[pos] = controlType;
    }
  }
}

RiskTypeController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'confirmDialog',
  'editRiskDialog',
  'loaderService',
  'assetDataService',
  'riskDataService',
  'riskSharedModelService',
  'ssDialogService',
  'editRiskTypeDialog',
  'deleteRiskTypeConfirmDialog',
  'controlSharedModelService',
];
